import { Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs";
import { EImageSize, EProductAssetType, IProductAvailabilityGetQuery, IProductAvailabilityGetQueryResult, ProductAssetGetByIdQueryResult, ProductAssetGetQueryResult, ProductAssortmentGetQueryResult, ProductDetailGetQueryResult, ProductGetByIntegraQueryQueryResult, ProductGetByProductCategoryQueryResult, ProductGetByTechGroupFilterQueryResult, ProductGetCategoryTreeQueryResult, ProductIdentifierDto, ProductIdentifierGetQueryResult, ProductOptionalGetQueryResult, ProductOrderPriceGetItemDto, ProductOrderPriceGetQueryResult, ProductPackagingTypeGetQueryResult, ProductPriceInfoGetItemDto, ProductPriceInfoGetQueryResult, ProductPromotionDetailGetQueryResult, ProductPromotionGetQueryResult, ProductQuantityScaleGetQueryResult, ProductSearchQueryResult, ProductStockInformationGetDto, ProductStockInformationGetQueryResult, ProductThumbnailGetQueryResult, TechGroupFilterDto } from "../../INTEGRA_Shop_Client";

@Injectable({
  providedIn: 'root'
})
export abstract class IProductApiService {

  abstract productIdentifierGet(
    productList?: ProductIdentifierDto[] | undefined,
  ): Observable<ProductIdentifierGetQueryResult>;

  abstract productSearch(
    searchtext?: string | undefined,
    maxResultCount?: number | undefined,
    useCancellationLogic?: boolean | undefined
  ): Observable<ProductSearchQueryResult>;

  abstract productDetailGet(
    loadDetailText: boolean,
    loadToolTipText: boolean,
    loadProductComparsionText: boolean,
    loadMetaDescriptionText: boolean,
    loadTagList: boolean,
    checkAvailabilityNotification: boolean,
    checkIsPromotionProduct: boolean,
    cartDate?: Date | undefined,
    productList?: ProductIdentifierDto[] | undefined,
    useCancellationLogic?: boolean | undefined
  ): Observable<ProductDetailGetQueryResult>;

  abstract productOrderPriceGet(
    productList?: ProductOrderPriceGetItemDto[] | undefined,
    deliveryAddressNumber?: number | undefined,
  ): Observable<ProductOrderPriceGetQueryResult>;

  abstract productPriceInfoGet(
    productList?: ProductPriceInfoGetItemDto[] | undefined,
    deliveryAddressNumber?: number | undefined,
    useCancellationLogic?: boolean | undefined
  ): Observable<ProductPriceInfoGetQueryResult>;

  abstract productAvailabilityGet(
    params?: Partial<IProductAvailabilityGetQuery>,
    allowCancellation?: boolean | undefined
  ): Observable<IProductAvailabilityGetQueryResult>;

  abstract productStockInformationGet(
    productList?: ProductStockInformationGetDto[] | undefined,
    requestDate?: Date | undefined,
    useCancellationLogic?: boolean | undefined
  ): Observable<ProductStockInformationGetQueryResult>;

  abstract productThumbnailGet(
    imageSize: EImageSize,
    productList?: ProductIdentifierDto[] | undefined,
    useCancellationLogic?: boolean | undefined
  ): Observable<ProductThumbnailGetQueryResult>;

  abstract productAssetGet(
    productList?: ProductIdentifierDto[] | undefined,
    productAssetType?: EProductAssetType | undefined,
  ): Observable<ProductAssetGetQueryResult>;

  abstract productAssetGetById(
    assetId: number,
  ): Observable<ProductAssetGetByIdQueryResult>;

  abstract productQuantityScaleGet(
    productList?: ProductIdentifierDto[] | undefined,
  ): Observable<ProductQuantityScaleGetQueryResult>;

  abstract productAssortmentGet(
    productList?: ProductIdentifierDto[] | undefined,
  ): Observable<ProductAssortmentGetQueryResult>;

  abstract productOptionalGet(
    productList?: ProductIdentifierDto[] | undefined,
  ): Observable<ProductOptionalGetQueryResult>;

  abstract productGetByTechGroupFilter(
    techGroupFilter?: TechGroupFilterDto | undefined,
  ): Observable<ProductGetByTechGroupFilterQueryResult>;

  abstract productGetByProductCategory(
    includeSubCategoryProducs: boolean,
    loadTechGroupNumberList: boolean,
    categoryKey?: string | undefined,
  ): Observable<ProductGetByProductCategoryQueryResult>;

  abstract productGetCategoryTree(
    productList?: ProductIdentifierDto[] | undefined,
  ): Observable<ProductGetCategoryTreeQueryResult>;

  abstract productPromotionGet(cartDate?: Date): Observable<ProductPromotionGetQueryResult>;

  abstract productPromotionDetailGet(
    productIdentifierList: ProductIdentifierDto[],
    requestDate: Date | undefined
  ): Observable<ProductPromotionDetailGetQueryResult>;

  abstract productGetByIntegraQuery(
    queryId: number,
    queryParameters?: { [key: string]: string; } | undefined,
  ): Observable<ProductGetByIntegraQueryQueryResult>;

  abstract productPackagingTypeGet(
    productIdentifierList?: ProductIdentifierDto[] | undefined
  ): Observable<ProductPackagingTypeGetQueryResult>;

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IProductApiServiceToken = new InjectionToken<IProductApiService>('IProductApiServiceToken');
